// extracted by mini-css-extract-plugin
export default {"dropdown":"ClassTagField_dropdown__xzbvN","rootColor":"ClassTagField_rootColor__+iaK0"};